const accessSubscription = {
    SUBSCRIPTION_ORDER_LIST: { name: 'Order List', path: '/order-list' },
    SUBSCRIPTION_PAYMENT_LIST: { name: 'Payment List', path: '/payment-list' }
}

export default accessSubscription;
